"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var configuration_1 = require("../configuration");
var PlacementFixer = (function () {
    function PlacementFixer() {
        this.fixtures = new Array();
        this.fixMethods = new Array();
        this._showCancelButton = false;
        this.setPlacementFixes();
    }
    PlacementFixer.prototype.setPlacementFixes = function () {
        var _this = this;
        this.fixtures.push(new PlacementFixture((function (placement) {
            if (placement.medium.type !== undefined && placement.medium.type !== "MO" && placement.medium.type !== "KZ") {
                return false;
            }
            return placement.frequency > 1 && placement.medium.period.charAt(0) !== "D";
        }), (function (placement, row) {
            var oldPeriod = _.get(row, "medium.period");
            if (oldPeriod === "KZ" || placement.medium.period === "KZ") {
                placement.medium.period = "KZ";
                placement.frequency = 1;
            }
            else {
                placement.medium.period = "DM";
            }
        }), "Frequency_SingleMonth_Error"));
        this.fixtures.push(new PlacementFixture((function (placement, row, edited) {
            var targeting = placement.targeting;
            var hasTargeting = (targeting !== undefined && targeting.keys.length > 0);
            var fcImpressions = _.get(placement, "frequencyCapping.impressions");
            var hasFrequencyCapping = (fcImpressions > 0);
            return (edited === "share" && (hasFrequencyCapping || hasTargeting));
        }), (function (placement, row) {
            _this.restorePlacement(placement, row["_placement"]);
        }), "FCWithShareOrTargeting_Error"));
        this.fixtures.push(new PlacementFixture((function (placement, row, edited) {
            if (placement.share !== undefined) {
                if (edited === "targeting.keys") {
                    return true;
                }
                if (edited === "additionalData.frequencyCappingFormatted" &&
                    placement.additionalData.frequencyCappingFormatted !== configuration_1.PlanConfiguration.ERROR_STRING) {
                    return true;
                }
            }
            return false;
        }), function (placement, row) {
            placement.pi = row["pi"];
            delete placement.share;
        }, "ShareOrTargetingWithFC_Error", true));
        this.fixtures.push(new PlacementFixture((function (placement) {
            return (placement.share === undefined && placement.pi === undefined);
        }), function (placement, row) {
            placement.pi = row["pi"] || 0;
        }));
        this.fixtures.push(new PlacementFixture((function (placement, row, edited) {
            if (!_.get(placement, "conditions.online")) {
                return false;
            }
            return placement.conditions.online.adFormat === "AGOF_Werbeform_0" && edited === "additionalData.frequencyCappingFormatted";
        }), function (placement, row) {
            _.noop();
        }, "FCWithoutAdformat"));
        this.fixtures.push(new PlacementFixture((function (placement, row) {
            return row["maxContactsAdformat"] < placement.pi;
        }), (function (placement, row) {
            var diff = PlacementFixer.calcDiffRounded(placement.pi, row["maxContactsAdformat"]);
            if (diff === 0) {
                placement.pi = row["maxContactsAdformat"];
            }
        }), "", false, false));
        this.fixtures.push(new PlacementFixture((function (placement, row, edited) {
            var placementAdFormat = _.get(placement, "conditions.online.adFormat");
            return (edited === "targeting.keys" &&
                placement.medium.key !== "DUMMY_MEDIUM" &&
                placementAdFormat === "AGOF_Werbeform_0");
        }), function (placement, row) {
            delete row["targeting"];
        }, "TargetingWithoutAdformat"));
    };
    PlacementFixer.calcDiffRounded = function (value1, value2) {
        var roundConstant = 1000;
        return Math.round(value1 / roundConstant) - Math.round(value2 / roundConstant);
    };
    PlacementFixer.prototype.checkPlacement = function (placement, row, editedField) {
        var _this = this;
        var errorMessage = "";
        var showCancelButton;
        var showPopup;
        this.fixtures.forEach(function (fixture) {
            if (fixture.failureCondition(placement, row, editedField)) {
                _this.fixMethods.push(fixture.fixReaction);
                _this._showCancelButton = fixture.showCancelButton;
                if (!errorMessage) {
                    errorMessage = fixture.errorMessage;
                }
                showCancelButton = fixture.showCancelButton;
                showPopup = fixture.showPopup || showPopup;
            }
        });
        return { message: errorMessage, showCancelButton: showCancelButton, showPopup: showPopup };
    };
    PlacementFixer.prototype.doFixes = function (placement, editedField, row) {
        this.fixtures.forEach(function (fixture) {
            if (fixture.failureCondition(placement, row, editedField)) {
                fixture.fixReaction(placement, row);
            }
        });
    };
    Object.defineProperty(PlacementFixer.prototype, "showCancelButton", {
        get: function () {
            return this._showCancelButton;
        },
        enumerable: true,
        configurable: true
    });
    PlacementFixer.prototype.restorePlacement = function (placement, oldPlacement) {
        var oldKeys = _.keys(oldPlacement);
        oldKeys.forEach(function (key) {
            if (!placement[key] && !_.isEqual(placement[key], oldPlacement[key])) {
                placement[key] = oldPlacement[key];
            }
        });
        var newKeys = _.keys(placement);
        newKeys.forEach(function (key) {
            if (!oldPlacement[key]) {
                delete placement[key];
            }
        });
    };
    return PlacementFixer;
}());
exports.PlacementFixer = PlacementFixer;
var PlacementFixture = (function () {
    function PlacementFixture(failureCondition, fixReaction, errorMessage, ignoreCancelButton, showPopup) {
        this._failureCondition = failureCondition;
        this._fixReaction = fixReaction;
        this._errorMessage = errorMessage || "";
        this._showCancelButton = ignoreCancelButton || false;
        this._showPopup = showPopup;
        if (showPopup === undefined) {
            this._showPopup = true;
        }
    }
    Object.defineProperty(PlacementFixture.prototype, "failureCondition", {
        get: function () {
            return this._failureCondition;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlacementFixture.prototype, "fixReaction", {
        get: function () {
            return this._fixReaction;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlacementFixture.prototype, "errorMessage", {
        get: function () {
            return this._errorMessage;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlacementFixture.prototype, "showCancelButton", {
        get: function () {
            return this._showCancelButton;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlacementFixture.prototype, "showPopup", {
        get: function () {
            return this._showPopup;
        },
        enumerable: true,
        configurable: true
    });
    return PlacementFixture;
}());
//# sourceMappingURL=placementFix.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/datalayer/placementFix.js
// module id = 58
// module chunks = 0